import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TabComponent {
  readonly active = signal(false);
  readonly title = input<string>();
  readonly body = input<string>();
  readonly tabIndex = input.required<number>();

  toggleActive(value: boolean) {
    this.active.set(value);
  }
}
